import React from "react";
import { motion } from "framer-motion";
import { Check, X } from "lucide-react";

const LETTERS = ["A", "B", "C", "D", "E", "F"];

const optionClass = ({ showFeedback, isCorrectIdx, isSelected, isWrongSelected }) => {
  if (showFeedback) {
    if (isCorrectIdx) return "border-brand-green bg-brand-green/10 text-brand-primary";
    if (isWrongSelected) return "border-brand-red bg-brand-red/8 text-brand-primary";
    return "border-brand-border opacity-55 text-brand-secondary";
  }
  if (isSelected) return "border-brand-green bg-brand-green/10 text-brand-primary";
  return "border-brand-border bg-brand-surface hover:border-brand-secondary text-brand-primary";
};

export default function AnswerOptions({
  question, selected, setSelected, result, showFeedback, submitting,
}) {
  return (
    <div className="mt-6 space-y-2.5">
      {question.options.map((opt, i) => {
        const isCorrectIdx = showFeedback && i === result.correct_index;
        const isWrongSelected = showFeedback && i === selected && !result.is_correct;
        const cls = optionClass({
          showFeedback, isCorrectIdx, isSelected: selected === i, isWrongSelected,
        });
        return (
          <motion.button
            key={`${question.question_id}-opt-${i}`}
            data-testid={`option-${i}`}
            disabled={showFeedback || submitting}
            onClick={() => setSelected(i)}
            whileTap={{ scale: 0.98 }}
            transition={{ type: "spring", stiffness: 500, damping: 30 }}
            className={`w-full text-left border rounded-xl px-4 py-3.5 transition-colors duration-150 flex items-start gap-3 ${cls}`}
          >
            <span className="font-serif text-base mt-0.5 text-brand-secondary">{LETTERS[i]}.</span>
            <span className="text-sm sm:text-base flex-1 leading-relaxed">{opt}</span>
            {isCorrectIdx && <Check className="h-4 w-4 text-brand-green mt-0.5" />}
            {isWrongSelected && <X className="h-4 w-4 text-brand-red mt-0.5" />}
          </motion.button>
        );
      })}
    </div>
  );
}
